import { Component, EventEmitter, Input, OnChanges, OnInit, Output, ViewChild } from "@angular/core";
import { VAutocompleteComponent } from "@app/directives/_forms/v-autocomplete/v-autocomplete.component";
import { ITag } from "@app/interfaces/ITag";
import { TagsService } from "@app/services/tags.service";
import { IPill } from "../../v-pills/v-pills.component";

@Component({
    selector: 'tag-selector',
    template: require('./tag-selector.component.html')
})
export class TagSelectorComponent implements OnInit, OnChanges {

    @Input() tagIds: number[];

    @Output() tagIdsChanged = new EventEmitter<number[]>();
  

    allTags: ITag[] = [];
    availableTags: ITag[];
    loading: boolean = true;
    tagPills: IPill<ITag>[] = [];

    @ViewChild('tagAutocomplete') dropdown: VAutocompleteComponent<ITag>;

    constructor(
        private readonly tagService: TagsService) { }

    ngOnInit(): void {
        this.load();
    }

    ngOnChanges(): void {
        this.renderPills();
    }

    onTagClicked(clickedTag: ITag): void {
        this.dropdown?.clearInput();

        this.addPill(clickedTag);

        this.tagIds = this.tagPills.map(pill => {
            return pill.data.Id;
        });

        const tagIndex = this.availableTags.findIndex(tag => tag.Id == clickedTag.Id);

        this.availableTags.splice(tagIndex, 1);

        this.tagIdsChanged.emit(this.tagIds);
    }

    onTagRemoved(pill: IPill<ITag>): void {
        const tag = pill.data;
        const selectedTagIndex = this.tagIds.findIndex(tagId => tagId === tag.Id);

        if (selectedTagIndex < 0) {
            this.renderPills();
            return;
        }

        this.availableTags.push(tag);

        this.tagIds.splice(selectedTagIndex, 1);
        this.renderPills();
        this.tagIdsChanged.emit(this.tagIds);
    }

    tagSearchPredicate(tag: ITag, text: string): boolean {
        return tag.Name?.toLowerCase().includes(text.toLowerCase());
    }

    //--

    private load(): void {
        this.loadTags();
    }

    private loadTags(): void {
        this.loading = true;
        this.tagService.getTags().then(tags => {
            this.allTags = tags;
            this.availableTags = this.allTags.filter(tag => !this.tagIds.find(tagId => tagId === tag.Id));
            this.renderPills();
        }).finally(() => {
            this.loading = false;
        })
    }

    private renderPills(): void {
        if (!this.allTags.length) {
            return;
        }

        this.tagPills = [];
        if (!this.tagIds) {
            return;
        }

        this.tagIds.forEach(tagId => {
            this.addPill(this.allTags.find(tag => tag.Id === tagId));
        })
    }

    private addPill(tag: ITag): void {
        if (!!this.tagPills.find(pill => pill.data.Id === tag.Id)) {
            return;
        }

        this.tagPills.push({
            data: tag,
            label: tag.Name,
            icon: 'close'
        })
    }
}
